'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glamor = require('glamor');

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

var _colors = require('../foundational-styles/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTrimStyle = function getTrimStyle(intent) {
  return {
    '&:before': {
      content: '""',
      width: 3,
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: _colors2.default.intent[intent]
    }
  };
};

/**
 * Get the themed props for the Alert component.
 * @param {Object} props
 * @param {string} props.appearance - default theme supports `default` and `card`.
 * @param {Intent} props.intent - intent of the alert. May be `none`.
 * @param {boolean} props.hasTrim - when true, the alert has a trim.
 * @return {Object} { className, ...themedProps }
 */
var getAlertProps = function getAlertProps(_ref) {
  var appearance = _ref.appearance,
      intent = _ref.intent,
      hasTrim = _ref.hasTrim;

  var trimClassName = hasTrim ? (0, _glamor.css)(getTrimStyle(intent)).toString() : '';

  switch (appearance) {
    case 'card':
      return { elevation: 1, borderRadius: 3, className: trimClassName };
    case 'default':
    default:
      return {
        boxShadow: 'inset 0 0 0 1px ' + _scales2.default.neutral.N4A,
        className: trimClassName
      };
  }
};

exports.default = getAlertProps;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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